<template>
  <div class="container">
    <!--  PC  -->
    <div class="pc-wrap">
      <div class="header">
        <div class="logo_wrap">
          <span class="logo-msg">欢迎使用</span>
          <img src="../assets/logo.png"/>
          <span class="logo-title">投标网</span>
        </div>
        <div class="hotline">
          <ul>
            <li>
              <img src="../assets/service_icon.jpg"/>
              <div>
                <p>服务热线</p>
                <p>022-27367214</p>
              </div>
            </li>
            <li>
              <img src="../assets/service_icon.jpg"/>
              <div>
                <p>业务投诉电话</p>
                <p>15321356666</p>
              </div>
            </li>
            <li>
              <img src="../assets/service_icon.jpg"/>
              <div>
                <p>业务投诉邮箱</p>
                <p>15321356666@163.com</p>
              </div>
            </li>
            <li v-if="!Info.userName">
              <el-button type="success" @click="toLogin">登录</el-button>
              <el-button @click="toRegister">注册</el-button>
            </li>
            <li v-if="Info.userName">
              <span style="margin-right: 10px">{{ Info.userName }}</span>
              <el-button type="success" @click="outLogin">退出登录</el-button>
            </li>
          </ul>
        </div>
      </div>

      <div class="navBar_wrap">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                 text-color="#FFFFFF" :router="true" :ellipsis="false">
          <el-menu-item index="/index" :route="{ path: '/index' }">首页</el-menu-item>
          <el-menu-item index="/announcement/zb" :route="{ path: '/announcement/zb' }">招标公告</el-menu-item>
          <el-menu-item index="/announcement/fzb" :route="{ path: '/announcement/fzb' }">非招标公告</el-menu-item>
          <el-menu-item index="/announcement/history" :route="{ path: '/announcement/history' }">历史招标记录
          </el-menu-item>
          <el-menu-item index="/product/list" :route="{ path: '/product/list' }">产品展示</el-menu-item>
          <el-menu-item index="/company/profile" :route="{ path: '/company/profile' }">公司介绍</el-menu-item>
        </el-menu>
      </div>
    </div>

    <!--  mobile  -->
    <div class="mobile-wrap">
      <div class="header-wrap">
        <div class="logo-wrap">
          <img src="../assets/logo-mobile.png"/>
          <span>时雨环保投标网</span>
        </div>
        <img class="vector" src="../assets/vector.png" @click="showPopup"/>

        <van-popup v-model:show="show" position="top" :style="{ height: '30%' }">
          <div class="navigation-mobile">
            <div class="navigation-mobile-list" v-for="(item,index) in navigationList" :key="index"
                 @click="GoNavigation(item.path)">
              <img :src="item.img" alt=""/>
              <span>{{ item.title }}</span>
            </div>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref, watch} from "vue";
import {useRouter, useRoute} from "vue-router";
import {ElMessage, ElMessageBox} from "element-plus";
import mobileIndex from "@/assets/mobile-index.png";
import mobileCompany from "@/assets/mobile-company.png";
import mobileLogin from "@/assets/mobile-login.png";
import mobileProduct from "@/assets/mobile-product.png";

export default defineComponent({
  setup() {
    const refs = ref;
    const route = useRoute();
    const router = useRouter();
    const activeIndex = ref("/index");
    const Info = ref({});
    const show = ref(false);
    const imgList = [mobileIndex, mobileCompany, mobileProduct, mobileLogin];
    const navigationList = [
      {img: mobileIndex, title: "首页", path: "/index"},
      {img: mobileProduct, title: "产品展示", path: "/product/list"},
      {img: mobileCompany, title: "关于公司", path: "/company/profile"},
      {img: mobileLogin, title: "登录", path: "/login"},
    ];

    if (sessionStorage.getItem("UserInfo")) {
      Info.value = JSON.parse(sessionStorage.getItem("UserInfo"));
    }

    watch(
        () => route.path,
        (val, old) => {
          activeIndex.value = val;
        },
        {
          deep: true,
          immediate: true,
        }
    );

    const toLogin = () => {
      router.replace({
        path: "/login",
      });
    };

    const toRegister = () => {
      router.replace({
        path: "/register",
      });
    };

    const handleSelect = (e) => {
      activeIndex.value = e;
      // if (e == '/announcement/history') {
      //   ElMessage({
      //     message: "请先登录",
      //     type: "warning",
      //   });
      //   router.replace({
      //     path: "/index",
      //   });
      //   return
      // }
      // router.replace({
      //   path: e,
      // });
    };

    const showPopup = () => {
      show.value = true;
    };

    const outLogin = () => {
      ElMessageBox.confirm("是否退出登录?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        router.replace({
          path: "/index",
        });
        sessionStorage.clear();
        setTimeout(function () {
          window.location.reload();
        }, 500);
      });
    };
    const GoNavigation = (e) => {
      router.replace({
        path: e,
      });
      show.value = false;
    };

    return {
      activeIndex,
      Info,
      show,
      navigationList,
      refs,
      toRegister,
      toLogin,
      handleSelect,
      outLogin,
      showPopup,
      GoNavigation,
    };
  },
});
</script>
<style lang="scss" scoped>
.pc-wrap {
  height: 120px;

  .header {
    background-color: #fafafa;
    padding: 13px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    .logo_wrap {
      display: flex;
      align-items: center;

      .logo-msg {
        color: #000;
        font-size: 12px;
        margin-right: 10px;
      }

      .logo-title {
        font-size: 12px;
        vertical-align: bottom;
        margin-left: 10px;
        font-weight: bold;
      }

      img {
        width: 136px;
        height: 35px;
      }
    }

    .hotline {
      margin-left: 8%;

      ul {
        display: flex;
        flex-wrap: wrap;

        li {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-right: 40px;

          img {
            width: 32px;
            height: 32px;
            margin-right: 10px;
          }
        }

        .avatar {
          display: inline-block;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #d5d5d5;
          overflow: hidden;
          margin-left: 128px;

          img {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }

  .navBar_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #3ab732;
    height: 65px;
  }

  .el-menu-demo {
    width: 1100px;
    height: 56px;
    background-color: #3ab732;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: none;
    color: var(--el-menu-active-color) !important;
    background-color: #fafafa;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    outline: 0;
    color: #3ab732;
    background-color: #fafafa;
  }
}

.mobile-wrap {
  width: 100%;
  display: none;

  .header-wrap {
    width: 100%;
    background-color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;

    .logo-wrap {
      display: flex;
      align-items: center;

      img {
        width: 48px;
        height: 48px;
      }

      span {
        margin-left: 10px;
        font-weight: bold;
        font-size: 18px;
      }
    }

    .vector {
      width: 25px;
      height: 20px;
    }
  }

  .navigation-mobile {
    padding: 10px;
  }

  .navigation-mobile-list {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    padding: 0 0 10px 0;
    margin-bottom: 20px;

    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
}
</style>
